import { registerLocaleData } from '@angular/common';
import skLocale from '@angular/common/locales/sk';
import { bootstrapApplication } from '@angular/platform-browser';
import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import 'reflect-metadata';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

Bugsnag.start({
  apiKey: 'cc58d39bcfeb1ee9501e8336089506fd',
  releaseStage: environment.stage,
  enabledReleaseStages: ['production', 'staging'],
});

BugsnagPerformance.start({
  apiKey: 'cc58d39bcfeb1ee9501e8336089506fd',
  releaseStage: environment.stage,
});

registerLocaleData(skLocale);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
